// pages/Admin.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserRole, getUserName, getLoginCode } from '../components/Auth';
import { useLoading } from '../components/LoadingContext';
import OrganizationSection from '../components/Admin/OrganizationSection';
import UserManagementSection from '../components/Admin/UserManagementSection';
import CurriculumVideoSection from '../components/Admin/CurriculumVideoSection';
import PhotoViewer from '../components/Admin/PhotoViewer';
import RoleBadge from '../components/RoleBadge';
import UncheckedDeliverablesCard from '../components/Admin/UncheckedDeliverablesCard';
import '../styles/Admin.css';

const Admin = () => {
  const navigate = useNavigate();
  const { loading, startLoading, finishLoading } = useLoading();

  const [role, setRole] = useState(undefined);
  const [userName, setUserName] = useState('');
  const [alertMessages, setAlertMessages] = useState([]);
  const [showPhotoViewer, setShowPhotoViewer] = useState(false);
  const [selectedUserToken, setSelectedUserToken] = useState(null);
  const [selectedCompanyToken, setSelectedCompanyToken] = useState(null);

  // 認証情報ロード（初回のみ）
  useEffect(() => {
    startLoading();
    const r = Number(getUserRole() || 0);
    setRole(r);
    setUserName(getUserName());
    finishLoading();
  }, [startLoading, finishLoading]);

  // 権限チェック
  useEffect(() => {
    if (role !== undefined && role < 5) {
      navigate('/', { replace: true });
    }
  }, [role, navigate]);

  // 未確認提出物アラートの取得
  useEffect(() => {
    const fetchAlerts = async () => {
      const loginCode = getLoginCode();
      if (!loginCode) return;

      try {
        const res = await fetch('https://5uqm251uv5.execute-api.ap-northeast-3.amazonaws.com/prod/api/admin/caution', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'get-unchecked-deliverables',
            login_code: loginCode,
          }),
        });
        const data = await res.json();
        if (Array.isArray(data.alerts)) {
          setAlertMessages(data.alerts);
        }
      } catch (err) {
        console.error('提出物アラート取得エラー:', err);
      }
    };

    if (role === 9 || role === 5) {
      fetchAlerts();
    }
  }, [role]);

  if (role === undefined) {
    return (
      <div className="loading-spinner">
        <p>Loading...</p>
      </div>
    );
  }
  if (role < 5) return null;

  return (
    <div className="admin-container" style={{ position: 'relative' }}>
      <h1>管理者ダッシュボード</h1>
      <p>ログイン中：{userName} <RoleBadge role={role} /></p>

      <UncheckedDeliverablesCard alerts={alertMessages} />

      {role === 9 && (
        <>
          <h2>事業所管理</h2>
          <OrganizationSection />
        </>
      )}

      <h2>利用者管理</h2>
      <UserManagementSection onPhotoView={(u, c) => {
        setSelectedUserToken(u);
        setSelectedCompanyToken(c);
        setShowPhotoViewer(true);
      }} />

      {role === 9 && (
        <>
          <h2>カリキュラム動画登録</h2>
          <CurriculumVideoSection />
        </>
      )}

      {showPhotoViewer && (
        <PhotoViewer
          userToken={selectedUserToken}
          companyToken={selectedCompanyToken}
          onClose={() => setShowPhotoViewer(false)}
        />
      )}

      {loading && (
        <div className="overlay-spinner">
          <div className="spinner-icon" />
          <p>Loading...</p>
        </div>
      )}
    </div>
  );
};

export default Admin;
